<template>
  <div>
    <div class="file" @click="lookFile">
      <img class="file-icon" src="https://peelprod.oss-cn-shenzhen.aliyuncs.com/biz/173026022759281382.png" />
      <div class="file-name">照片视频</div>
    </div>

    <Mdialog
      title="查看照片视频"
      :visible.sync="dialog"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="false"
      :destroy-on-close="true"
      @closes="close"
    >
      <Photo :imgArr="imgArr" :videoArr="videoArr" />
    </Mdialog>
  </div>
</template>

<script>
import Mdialog from '@/components/Mdialog'
import Photo from '@/components/photo.vue'

export default {
  name: 'Inspection',
  components: {
    Mdialog,
    Photo,
  },
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,

      formData: { attachments: [] },

      imgArr: [],
      videoArr: [],
    }
  },
  mounted() {
  },
  methods: {

    close() {
      this.imgArr = []
      this.videoArr = []
      this.dialog = false
    },


    lookFile() {
      this.imgArr =
        this.fileList?.filter((item) => item.type == 2).map((item) => item.url) || []
      this.videoArr =
        this.fileList
          ?.filter((item) => item.type == 3)
          .map((item) => ({ fileUrl: item.url })) || []
      this.dialog = true
    },
   
  },
}
</script>

<style scoped lang="less">
@import '~@/assets/variables.less';
@import '~@/assets/form.less';

.file {
  display: inline-block;
  cursor: pointer;
  &-icon {
    width: 100px;
    height: 100px;
  }
  &-name {
    font-size: 16px;
    text-align: center;
  }
}
</style>
